import React, { useState, useEffect } from 'react';
import toast, { Toaster } from 'react-hot-toast';
import { TextField } from '@material-ui/core';
import { Autocomplete } from '@material-ui/lab';
import { withAuthenticationRequired } from '@auth0/auth0-react';
import { Card, CardBody, CardTitle, Breadcrumb, BreadcrumbItem, Row, Col } from 'reactstrap';

//Componentes
import Loading from '../../components/modales/loadingModal';
import DownloadTableButton from '../../components/buttons/downloadTableButton';
import ModalAsignacionContratador from './componentes/modalAsignacionContratador';
import ModalExportacionAPE from './componentes/modalExportacionAPE';
import ListadoAPE from '../../components/lists/ListadoAPE';

//Redux
import { connect } from 'react-redux';

//Funciones
import { userRolValidation } from '../../utils/userValidation/rolValidation'

//GCP Functions
import { functionsHttpsCallable } from '../../utils/FirebaseStorage/firebase';

//API Calls
const listadoAPE = functionsHttpsCallable('ape_listadoSolicitudesContratacion');
const exportarInformeContratacion = functionsHttpsCallable('ape_exportarInformeContratacion');
//API Calls


const mapStateToProps = state => ({
    usuarioActivo: state
})

//Toast
const toastSuccess = (msg) => toast.success(msg);
const toastError = (msg) => toast.error(msg);

const GestorContratacion = (props) => {
    const [userData] = useState(JSON.parse(localStorage.getItem('userData')));
    const [campoBusqueda, setCampoBusqueda] = useState('');
    const [campo, setCampo] = useState('');
    const [userId, setUserId] = useState(parseInt(userData.userId));
    const [listaSolicitudes, setListaSolicitudes] = useState([]);
    const [listaSolicitudesFilter, setListaSolicitudesFilter] = useState([]);
    const [modalInforme, setModalInforme] = useState(false);
    const [modalContratadores, setModalContratadores] = useState(false);
    const [modalVisualizacion, setModalVisualizacion] = useState(false);
    const [permisos, setPermisos] = useState({ descarga: false });
    const [solicitudActiva, setSolicitudActiva] = useState();
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        let permisosTemp = getPermissions()
        setPermisos(permisosTemp)
        getDataSolicitudes()
        document.title = "Proceso de Selección";
    }, [])

    useEffect(() => {
        handleBusqueda()
    }, [campoBusqueda])

    const downloadInforme = async (body) => {
        const bodyExp = {
            fechaInicio: body.start,
            fechaFin: body.end,
            codigoEmpresa: parseInt(userData.codigoEmpresa)
        }
        setLoading(true);
        try{
            const downloadLink = await exportarInformeContratacion(bodyExp);
            let downloadWindow = window.open(downloadLink.data.data, "_blank", "noopener,noreferrer")
            if (downloadWindow) downloadWindow.opener = null
            toastSuccess('Descarga exitosa');
            setLoading(false);
        }
        catch (error) {
            toastSuccess(`Error ${error.message ?? ''}`);
            setLoading(false);
        }
        
    }

    const getDataSolicitudes = async () => {
        try {
            let body = {
                userId: userId,
                cod_empr: parseInt(userData.codigoEmpresa)
            }
            let dataSolicitudes = await listadoAPE(body)
            setListaSolicitudes(formatListado(dataSolicitudes.data.data))
            setListaSolicitudesFilter(formatListado(dataSolicitudes.data.data))
            setLoading(false)
        }
        catch (e) {
            console.log('error', e)
        }
    }


    const formatListado = (listado) => {
      const newList = [];
      listado.forEach((item) => {
        newList.push({
          id: item.solicitudId,
          cargo: item.codigoCargo,
          color: "info",
          estado: item.estadoAPE,
          campo: item.campo,
          creador: item.cedulaCreador,
          responsable: item.codigoActual,
          cliente: item.clienteComercial,
          name: item.nombreReclutador,
          nombreCandidato: item.nombreCandidato,
          cedulaCandidato: item.cedulaCandidato ? item.cedulaCandidato : "",
          contrato: item.numeroContrato ? item.numeroContrato : "",
        });
      });
      return newList;
    };

    // const getColor = (startDate) => {
    //     let todayDate = new Date(new Date(Date.now()).getTime() - 5 * 60 * 60 * 1000)
    //     let newStartDate = new Date(startDate)
    //     let diference = ((todayDate - newStartDate) / (24 * 60 * 60 * 1000))
    //     if (diference < 10) return 'success'
    //     else if (diference < 20) return 'warning'
    //     else return 'danger'

    // }
    const getPermissions = () => {
        let rolesDescarga = ['administrador', 'contratador']
        let rolesInforme = ['administrador']
        let validacion = {
            descarga: userRolValidation(rolesDescarga, userData),
            informe: userRolValidation(rolesInforme, userData)
        }
        return validacion
    }

    const handleBusqueda = () =>{
        let solicitudesPropiasTemp
        if (campoBusqueda !== '' && campoBusqueda !== undefined) {
            if (campo) {
                if (listaSolicitudes && listaSolicitudes.length > 0) {
                  solicitudesPropiasTemp = listaSolicitudes.filter(
                    (solicitud) =>
                      solicitud[campo]
                        .toString()
                        .includes(campoBusqueda.toUpperCase())
                  );
                }
            }
            else {
                solicitudesPropiasTemp = listaSolicitudes
            }
        }
        else {
            solicitudesPropiasTemp = listaSolicitudes
        }
        setListaSolicitudesFilter(solicitudesPropiasTemp)
    }

    const renderListaSolicitudes = () => {
        return (
            <ListadoAPE
                listaSolicitudes={listaSolicitudesFilter}
                linkTo={'/home/proceso-contratacion/ape/'}
                proceso={'contratacion'}
                enableButton={
                  userData.roles.includes("contratador") ||
                  userData.roles.includes("administrador")
                }
                onClickAux={(e)=>handleToggleContratador(e)}/>
        )

    }

    const handleToggleContratador = (idSolicitud) => {
        setSolicitudActiva(idSolicitud);
        toggleContratadores()
    }

    const renderModalContratadores = () => {
        return (
            <ModalAsignacionContratador
                toastSuccess={(e) => { toastSuccess(e) }}
                toastError={(e) => { toastError(e) }}
                toggle={() => { toggleContratadores() }}
                modal={modalContratadores}
                solicitud={solicitudActiva}
            />
        )
    }

    const renderModalExportacion = () => {
        return (
            <ModalExportacionAPE
                toggle={() => { toggleExportacionInforme() }}
                modal={modalInforme}
                toastSuccess={toastSuccess}
                toastError={toastError}
                // data={dataModal}
                action={(e) => downloadInforme(e)}
            />
        );
    }

    const toggleVisualizacionInforme = () => setModalVisualizacion(prevModalVisualizacion => !prevModalVisualizacion);
    const toggleExportacionInforme = () => setModalInforme(prevModalInforme => !prevModalInforme);
    const toggleContratadores = () => setModalContratadores(prevModalContratadores => !prevModalContratadores);

    return loading ? (
      <div className={"loading-area"}>
        <Loading />
      </div>
    ) : (
      <>
        <Toaster />
        {renderModalExportacion()}
        {renderModalContratadores()}
        <Breadcrumb>
          <BreadcrumbItem className="breadcum-display-content" active>
            Resumen de Solicitudes
            <div>
              {permisos.descarga ? (
                <DownloadTableButton
                  onClick={() => {
                    toggleExportacionInforme();
                  }}
                />
              ) : null}
            </div>
          </BreadcrumbItem>
        </Breadcrumb>
        <Card>
          <CardBody>
            <CardTitle tag="h5">Solicitudes</CardTitle>
          </CardBody>
          <CardBody>
            <Row>
              <Col lg="10" md="8" xs="12">
                <TextField
                  required
                  autoComplete="off"
                  key={`key_busqueda`}
                  id={`input_busqueda`}
                  fullWidth
                  label={"Busqueda"}
                  onChange={(e) => setCampoBusqueda(e.target.value)}
                  defaultValue=""
                  margin="normal"
                />
              </Col>
              <Col lg="2" md="4" xs="12">
                <Autocomplete
                  required
                  margin="dense"
                  options={[
                    { label: "Numero APE", value: "id" },
                    { label: "Campo", value: "campo" },
                    { label: "Cargo", value: "cargo" },
                    { label: "Contrato", value: "contrato" },
                    { label: "Cédula Candidato", value: "cedulaCandidato" },
                  ]}
                  key={`key_Cargo`}
                  id={`select_Cargo`}
                  onChange={(event, newValue) => {
                    if (newValue) {
                      setCampo(newValue.value);
                    } else {
                      setCampo(undefined);
                      setListaSolicitudesFilter([...listaSolicitudes]);
                    }
                  }}
                  renderInput={(params) => (
                    <TextField {...params} label={"Campo"} margin="normal" />
                  )}
                  getOptionLabel={(option) => option.label}
                  renderOption={(option) => (
                    <React.Fragment>{option.label}</React.Fragment>
                  )}
                />
              </Col>
            </Row>
            {renderListaSolicitudes()}
          </CardBody>
        </Card>
      </>
    );
}

export default withAuthenticationRequired(connect(mapStateToProps)(GestorContratacion), {
    onRedirecting: () => <Loading />,
  });